import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import TextArea from 'antd/lib/input/TextArea';
import React, { useState } from 'react';

type RejectExpenseModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: RejectExpenseValues) => Promise<void>;
};

export type RejectExpenseValues = {
  reason: string;
};

const RejectExpenseModal: React.FC<RejectExpenseModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
}) => {
  const { messages } = useTypedIntl();

  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onFinish: FormProps['onFinish'] = (values) => {
    setIsSubmitting(true);
    onSubmit(values)
      .then(() => {
        toggle();
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title={messages['common.rejectExpense']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.confirm'],
          buttonType: 'primary',
          onClick: () => form.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <Form.Item
          label={messages['common.reason']}
          name="reason"
          rules={[
            {
              required: true,
              message: messages['form.pleaseEnter'],
            },
          ]}
        >
          <TextArea rows={4} placeholder={messages['common.enter']} />
        </Form.Item>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default RejectExpenseModal;
